// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
//import ReactDOM from "react-dom";
import './App.css';
import { Communication } from "@fluentui/react-teams";
import { DefaultButton } from '@fluentui/react/lib/Button';
import * as microsoftTeams from "@microsoft/teams-js";
import { useHistory } from "react-router-dom";
import urlProps from "../resources/properties";

/**
 * The 'PersonalTab' component renders the main tab content
 * of your app.
 */
const Login = (props) => {

    document.body.style.overflow = "hidden"

    const history = useHistory();

    
    const query = new URLSearchParams(props.location.search);

    const cockpit = query.get('cockpit')
    console.log(cockpit);

    const openAuthPopup = (x) => {
        console.log("test");


        //      microsoftTeams.initialize(
        //           () => {
        microsoftTeams.authentication.authenticate({
            url: cockpit? cockpit: urlProps.properties.enmLink.getBaseUrl(),
            width: 600,
            height: 535,
            successCallback: function (result) {
                console.log(result)
            },
            failureCallback: function (reason) {
                console.log(reason)
                history.replace("/enm?cockpit=" + cockpit);
            }
        });
        //   }
        //  );



    }

    const CommunicationProps =
    {
        "fields": {
            "title": "Willkommen in der VANTAiO Enterprise News Manager App",
            "desc": "Bitte melden Sie sich an um fortzufahren",
            "actions": {
                "primary": {
                    "label": "Login",
                    "target": "/enm",
                    "onclick": openAuthPopup
                }
            }
        }
    };

    return (
        <div>
            <Communication option="Welcome" fields={CommunicationProps.fields} onInteraction={openAuthPopup}></Communication>
        </div>
    );
}
export default Login;